/**
 * Inline edit dialog for an existing job cost row.
 */
import { useState } from 'react'
import type { JobCostRow } from '../../../../api/costsMargin'
import { localDateKey } from '../../../../lib/localDate'
import MoneyInput from '../../../../components/MoneyInput'
import { formatMoneyInputBlur } from '../../../../lib/formatters'

export default function EditCostDialog({
  row,
  onClose,
  onSave,
}: {
  row: JobCostRow
  onClose: () => void
  onSave: (patch: { description: string; amount_cents: number; due_date: string | null }) => Promise<void>
}) {
  const [description, setDescription] = useState(row.description)
  const [amount, setAmount] = useState(formatMoneyInputBlur(String(row.amount_cents / 100)))
  const [due, setDue] = useState((row.due_date || localDateKey()).slice(0, 10))
  return (
    <div className="cm-dialog show" role="dialog" aria-modal="true" data-testid="cm-edit-cost">
      <div className="cm-dialog-card">
        <h2>Edit cost</h2>
        <div style={{ padding: '0 18px 12px', display: 'grid', gap: 8 }}>
          <input value={description} onChange={(e) => setDescription(e.target.value)} />
          <MoneyInput value={amount} onChange={setAmount} />
          <label>
            When is this paid?
            <input
              type="date"
              value={due}
              onChange={(e) => setDue(e.target.value)}
              required
              data-testid="cm-edit-due"
            />
          </label>
        </div>
        <div className="cm-dialog-actions">
          <button type="button" className="cm-btn" onClick={onClose}>Cancel</button>
          <button
            type="button"
            className="cm-btn cm-btn-dark"
            onClick={() => {
              const dollars = parseFloat(amount.replace(/[^0-9.]/g, ''))
              if (!Number.isFinite(dollars) || !due) return
              void onSave({ description, amount_cents: Math.round(dollars * 100), due_date: due })
            }}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  )
}
